import { makeStyles } from "@material-ui/core/styles";

export const useFormControlStyles = makeStyles(() => ({
  label: {
    display: "block",
    margin: "0 0 8px 0",
    whiteSpace: "nowrap",
  },
  wrapper: {
    display: "block",
    margin: "0 0 20px 0",
  },
}));
